import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Spinner.css";
import "./hm-theme.css";

const AddFamily = ({ isOpen, onRequestClose, userid }) => {
  const [family, setFamily] = useState({
    name: "",
    lastname: "",
    aadhaarnumber: "",
    relationship: "",
    phoneNumber: "",
    gender: "",
    dob: "",
    address: "",
    pan: "",
    image: null,
    imageMeta: "",
    userid: userid,
  });
  const [loading, setLoading] = useState(false);
  const [relationship, setRelationship] = useState([]);

  const genderOptions = ['Male', 'Female'];
  const url = "/api/familydetails/create";
  const navigate = useNavigate();

  useEffect(() => {
    fetchProductTypes();
  }, []);

  const fetchProductTypes = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("data"))?.token;
      const response = await axios.get("/api/relationship", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRelationship(response.data || []);
    } catch (error) {
      handleError(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data"))?.token;
    try {
      await axios.post(url, family, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoading(false);
      toast.success("Family Details Added successfully");
      onRequestClose();
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const rhandle = (e) => {
    const { id, value, type, name } = e.target;
    setFamily((prevState) => ({
      ...prevState,
      [type === 'radio' ? name : id]: value,
    }));
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered size="lg">
      <Modal.Header closeButton className="border-bottom px-4 py-3">
        <Modal.Title className="h5 fw-bold mb-0 d-flex align-items-center gap-2" style={{ color: "#1e293b" }}>
          <i className="material-icons text-primary">group_add</i>
          Add Family Details
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body className="p-4">
          <div className="row g-3">
            <div className="col-md-6">
              <label htmlFor="name" className="form-label small fw-semibold">
                Name <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                id="name"
                type="text"
                placeholder="Name"
                value={family.name}
                onChange={rhandle}
                required
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="dob" className="form-label small fw-semibold">
                Date of Birth <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                id="dob"
                type="date"
                placeholder="Date Of Birth"
                value={family.dob}
                onChange={rhandle}
                required
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="phoneNumber" className="form-label small fw-semibold">
                Phone Number
              </label>
              <input
                className="form-control"
                id="phoneNumber"
                type="text"
                placeholder="Phone Number"
                value={family.phoneNumber}
                onChange={rhandle}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="aadhaarnumber" className="form-label small fw-semibold">
                Aadhaar Number
              </label>
              <input
                className="form-control"
                id="aadhaarnumber"
                type="text"
                placeholder="Aadhaar Number"
                value={family.aadhaarnumber}
                onChange={rhandle}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="pan" className="form-label small fw-semibold">
                PAN
              </label>
              <input
                className="form-control"
                id="pan"
                type="text"
                placeholder="PAN"
                value={family.pan}
                onChange={rhandle}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="relationship" className="form-label small fw-semibold">
                Relationship Status <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                id="relationship"
                name="relationship"
                value={family.relationship}
                onChange={rhandle}
                required
              >
                <option value="">Select relationship</option>
                {relationship.map((type) => (
                  <option key={type.id} value={type.relationshipStatus}>
                    {type.relationshipStatus}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-12">
              <label className="form-label small fw-semibold me-3">
                Gender <span className="text-danger">*</span>
              </label>
              <div className="d-flex align-items-center gap-4 mt-1">
                {genderOptions.map((gender, index) => (
                  <div key={index} className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id={`gender-${gender}`}
                      name="gender"
                      value={gender}
                      checked={family.gender === gender}
                      onChange={rhandle}
                      required
                    />
                    <label className="form-check-label small" htmlFor={`gender-${gender}`}>
                      {gender}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="address" className="form-label small fw-semibold">
                Address
              </label>
              <textarea
                className="form-control"
                id="address"
                placeholder="Address"
                value={family.address}
                onChange={rhandle}
                rows="2"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top px-4 py-3">
          <Button variant="outline-secondary" className="rounded-pill px-4" onClick={onRequestClose}>
            Close
          </Button>
          <button type="submit" className="btn-hm-primary px-4" disabled={loading}>
            {loading ? "Saving..." : "Save Member"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default AddFamily;

